module.exports = __webpack_public_path__ + "static/media/portfolio1 (38).37d9a943.jpeg";